export enum CustomFunctionName {
  StudentsHandler = "studentsHandler",
  TestsHandler = "testsHandler",
  ReteynerHandler = "reteynerHandler",
  ReportHandler = "reportHandler",
  QuestionHandler = "questionHandler",
  LearnerHistoryHandler = "learnerHistoryHandler",
  LeaderboardHandler = "leaderboardHandler",
}
